module.exports = __webpack_public_path__ + "static/img/Herve-Coureil_2017-18.ca6f582.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company-performance/leadership/Herve-Coureil_2017-18.jpg
// module id = l2VI
// module chunks = 0